import PatientInformation from "./PatientInformation";
import InsuranceInformation from "./Insurance";
import MedicalHistory from "./MedicalHistory";
import ReferralHistory from "./ReferralHistory";
import SocialHistory from "./SocialHistory";
import Payment from "./Payment";
import Relations from "./Relations";
import Locations from "./Locations";
import {
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Box,
    VStack,
    Heading,
    Text,
  } from "@chakra-ui/react";

  const tabStyle = {
    fontSize: "12px",
    color: "#6b7280",
    px: 3,
    py: 1.5,
    borderRadius: "6px",
    whiteSpace: "nowrap",
    transition: "all 0.15s ease",
    _selected: {bg: "#f8f9fa", color: "#1a1f36", fontWeight: 600},
    _hover: {bg: "#f8f9fa"},
  };

  const panelStyle = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: 0,
  };

  function Profile({state, dispatch}) {
    return (
      <VStack w="full" flex={1} overflow="hidden" alignItems="stretch">
        <Box px={{base: 4, md: 6}} pt={5} pb={2}>
            <Heading
              as="h2"
              fontSize="xl"
              color="#1a1f36"
              fontWeight="600"
            >
              Profile
            </Heading>
            <Text
              fontSize="14px"
              color="#6b7280"
              mt={1}
            >
              View and manage your profile information
            </Text>
          </Box>
      <Tabs
       variant="unstyled"
       display={"flex"}
       flexDirection={"column"}
       flex={1}
       overflow="hidden"
       px={{base: 4, md: 6}}
       isLazy
     >
       <Box
         mb={4}
         overflowX="auto"
         css={{
           '&::-webkit-scrollbar': { display: 'none' },
           scrollbarWidth: 'none',
         }}
       >
         <TabList gap={1} minW="max-content" justifyContent="center">
            <Tab {...tabStyle}>Personal</Tab>
            <Tab {...tabStyle}>Medical</Tab>
            <Tab {...tabStyle}>Insurance</Tab>
            <Tab {...tabStyle}>Referral</Tab>
            <Tab {...tabStyle}>Social</Tab>
            <Tab {...tabStyle}>Payment</Tab>
            <Tab {...tabStyle}>Relations</Tab>
            <Tab {...tabStyle}>Locations</Tab>
          </TabList>
       </Box>
      <TabPanels w="full" paddingRight={0} display="flex" overflow="auto" flex={1} flexDirection="column">
        <TabPanel {...panelStyle}>
          <PatientInformation state={state} dispatch={dispatch} />
        </TabPanel>
        <TabPanel {...panelStyle}>
          <MedicalHistory state={state} dispatch={dispatch} />
        </TabPanel>
        <TabPanel {...panelStyle}>
          <InsuranceInformation state={state} dispatch={dispatch} />
        </TabPanel>
        <TabPanel {...panelStyle}>
          <ReferralHistory state={state} dispatch={dispatch} />
        </TabPanel>
        <TabPanel {...panelStyle}>
          <SocialHistory state={state} dispatch={dispatch} />
        </TabPanel>
        <TabPanel {...panelStyle}>
          <Payment state={state} dispatch={dispatch} />
        </TabPanel>
        <TabPanel {...panelStyle}>
          <Relations state={state} dispatch={dispatch} />
        </TabPanel>
        <TabPanel {...panelStyle}>
          <Locations state={state} dispatch={dispatch} />
        </TabPanel>
      </TabPanels>
    </Tabs>
    </VStack>
    );
  }

  export default Profile;
